























import { Component, Vue } from 'vue-property-decorator';

import mainStore from '@/store/main-store/MainStore';

import CarouselProducts from '@/components/products/CarouselProducts.vue';

import { Products } from '@/models/Products';

@Component({
    name: 'Home',
    components: {
        CarouselProducts,
    },
})
export default class Home extends Vue {
    private mainStore = mainStore.context(this.$store);

    private get products(): Products[] {
        return this.mainStore.state.products;
    }

    private get isLoading(): boolean {
        return this.mainStore.state.isLoading;
    }

    private addProductToCar(product: Products): void {
        this.mainStore.actions.addProductToCar(product);
    }
}
